var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shareState)?_c('div',{attrs:{"id":"share"}},[_c('bv-bind-phone',{attrs:{"spacial":{state:true},"show-bind-phone-status":true},on:{"close-bind-phone":_vm.closeBindPhoneShare}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }